<script>
    import { fade } from "svelte/transition";

    import {
        disableItemsMap,
        getAsaItemCodeLabel,
        updateModifierItems,
    } from "../../../helpers/asaHelper.svelte";

    export let itemProps = {},
        defaultItems = [],
        selectedItems = [],
        modifierMap = new Map(),
        noDisplayModifierItems = [],
        updateItems = () => {},
        openNotification = () => {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: if (defaultItems.length) _syncDisplayItems();

    let displayItems = [];

    const handleSelectItem = (item) => {
        updateItems(
            updateModifierItems(
                item,
                selectedItems,
                modifierMap,
                openNotification,
            ),
        );
    };

    // HELPER FUNCTIONS
    const _syncDisplayItems = () => {
        displayItems = defaultItems
            .filter((item) => !noDisplayModifierItems.includes(item.itemCode))
            .sort((a, b) => a.id - b.id);
    };
</script>

<div
    class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4"
    transition:fade={{ duration: isCardiacEncounter ? 100 : 0 }}
>
    <div class="flex flex-1 items-center">
        <p class="w-auto min-w-[6rem] font-bold text-lg">Modifiers</p>
    </div>

    <div class="flex flex-wrap gap-4 w-full">
        {#each displayItems.filter(({ itemCode }) => itemCode != "M2" && itemCode != "M4") as item}
            <button
                class={`btn btn-sm rounded rounded-full text-xs hover:btn-primary ${
                    selectedItems.some((itm) => itm.id == item.id)
                        ? "btn-primary"
                        : "btn-secondary"
                }`}
                disabled={disableItemsMap.has(item.itemCode) &&
                    selectedItems.some((sItem) =>
                        disableItemsMap
                            .get(item.itemCode)
                            .includes(sItem.itemCode),
                    )}
                on:click|preventDefault={() => handleSelectItem(item)}
            >
                {getAsaItemCodeLabel(item)}
                {item.infoShortTitle}
            </button>
        {/each}
    </div>

    <div class="flex flex-wrap gap-4 w-full">
        {#each displayItems.filter(({ itemCode }) => itemCode == "M2" || itemCode == "M4") as item}
            <button
                class={`btn btn-sm rounded rounded-full text-xs hover:btn-primary ${
                    selectedItems.some((itm) => itm.id == item.id)
                        ? "btn-primary"
                        : "btn-secondary"
                }`}
                on:click|preventDefault={() => handleSelectItem(item)}
            >
                {item.itemCode == "M2"
                    ? "M2 - In hours Emergency"
                    : "M4 - Out of hours Emergency"}
            </button>
        {/each}
    </div>
</div>
